function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3239"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3230"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3227"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 8",
  cx: 26.746,
  cy: 26.746,
  r: 26.746,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(47.958 72.502)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3228"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 9",
  cx: 20.053,
  cy: 20.053,
  r: 20.053,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(54.547 79.196)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3229"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 10",
  cx: 5.925,
  cy: 5.925,
  r: 5.925,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(68.78 93.324)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3234"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3231"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 11",
  cx: 26.746,
  cy: 26.746,
  r: 26.746,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(270.318 72.502)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3232"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 12",
  cx: 20.053,
  cy: 20.053,
  r: 20.053,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(276.908 79.196)"
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3233"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 13",
  cx: 5.925,
  cy: 5.925,
  r: 5.925,
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  transform: "translate(291.14 93.324)"
}))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3235"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2858",
  d: "M326.694 51.573c-.15 3.581-.216 2.882 2.073 5.971 2.222 3 2.451 3.992 4.34 2.106s1.457-6.882 1.411-8.171c-.024-.683-7.784-.866-7.824.094z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2859",
  d: "M6.676 74.758c-3 0-5.287-.274-5.584 1.3s-.2 2.137.572 4.029c.857 2.092 3 7.428 5.678 7.611s6.134.355 6.111-.858",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3236"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2860",
  d: "M328.685 80.109c-1.37.726-1.582 1.37-1.582 1.37s-3.455 16.829.225 16.775 8.114-1.235 9.082-3.761 4.938-14.122 1.52-15.977",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3237"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2861",
  d: "M202.638 50.393a1.258 1.258 0 00-1.257-1.259h-10.724a1.259 1.259 0 00-1.257 1.259v2.514a1.259 1.259 0 001.257 1.259h10.724a1.258 1.258 0 001.257-1.259z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 3238"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2862",
  d: "M139.842 49.337a1.259 1.259 0 00-1.258-1.258h-10.723a1.259 1.259 0 00-1.258 1.258v2.514a1.259 1.259 0 001.258 1.259h10.724a1.259 1.259 0 001.258-1.259z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2863",
  d: "M104.854 91.886c-.456-2.728-6.024-31.907-35.463-31.2-27.331.652-25.526 27.845-25.526 27.845a250.983 250.983 0 01-31.1-1.769c-.425-.05-3.33-6.735-5.385-10.928-3-6.118-9.082-27.4-3.129-40.054.475-1.009 47.872-.685 57.812-.7 8.5-.012 40.167.263 52.752.108.637-12.653 2.745-26.07 6.391-31.88 1.991-3.171 46.285-2.285 59.14-2.071 13.806.23 30.942.759 40.778 3.58 2.195.629 18.377 11.161 23.214 14.736s17.084 13.353 19.874 13.682c9.923 1.172 64.764 8.413 69 12.552 2.514 2.457 4.129 9.467 4.6 16.306.389 5.642.9 18.2-1.323 19.453-3.554 2-6.874-.182-7.1-.746-1.68-4.193-16.1-19.351-32.879-18.991-16.953.364-26.7 17.4-29.585 30.079z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2864",
  d: "M184.28 38.929c-4.843-.11-14.007-.314-20.569-.432-10.361-.185-25.2.026-30.318-2.512-3.961-1.964-3.883-3.014-3.384-14.28.593-13.4 1.628-13.831 3.168-14.425.954-.368 8.7-.085 21.175-.29 10.609-.175 24.468.2 28.889.334.233 3.824.647 11.177.736 16.327.126 7.247-.075 12.85.074 13.7.084.48.16 1.008.229 1.578z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2865",
  d: "M183.244 7.356c4.938.12 31.112.564 36.1 2.709 5.268 2.265 13.025 7.039 19.542 11.338a167.514 167.514 0 0118.2 14.631 7.477 7.477 0 011.3 4.7c0 .451-43.306-1.032-46.383-1.012-4.337.028-20.063-.522-27.724-.748a29.324 29.324 0 00-.234-1.62c-.149-.851.052-6.454-.074-13.7-.08-5.139-.494-12.466-.727-16.298z",
  fill: "none",
  stroke: "#b8b7b7",
  strokeMiterlimit: 10,
  strokeWidth: 2
}));

function SvgPassengerSideGraphic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310.459,
    height: 126.994,
    viewBox: "0 0 340 127"
  }, props), _ref);
}

export default SvgPassengerSideGraphic;